module.exports = __webpack_public_path__ + "static/img/jpg.f9154ec1.png";